// Editorial page header — bold typography, single-color band, big number optional.
import { Sparkles } from "lucide-react";

export default function PageHero({
  title,
  subtitle,
  eyebrow,
  kpi,             // { label, value, hint }
  action,          // JSX
  tone = "warm",   // 'warm' | 'ink' | 'sky'
  children,
}) {
  const styles = {
    warm: { bg: "#F4F5EF", fg: "#111", eyebrow: "#1769E0", accent: "#FF9F1C" },
    ink:  { bg: "#0B1F33", fg: "#fff", eyebrow: "#FFD166", accent: "#FF9F1C" },
    sky:  { bg: "#DCEBFF", fg: "#0B1F33", eyebrow: "#1769E0", accent: "#FF9F1C" },
  }[tone] || {};

  return (
    <div className="mb-10" data-testid="page-hero" style={{ color: styles.fg }}>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <div className="flex-1 min-w-0">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em]" style={{ color: styles.eyebrow }}>
              <Sparkles className="w-3 h-3" />
              {eyebrow}
            </div>
          )}
          <h1 className="page-title mt-3">{title}</h1>
          {subtitle && <p className="page-subtitle max-w-2xl">{subtitle}</p>}
          {children && <div className="mt-5">{children}</div>}
        </div>

        <div className="flex flex-wrap items-end gap-4 sm:gap-8 lg:shrink-0 w-full lg:w-auto [&>*]:min-w-0">
          {kpi && (
            <div>
              <div className="text-[10.5px] uppercase tracking-widest font-bold" style={{ color: styles.eyebrow }}>{kpi.label}</div>
              <div className="mt-1 text-[40px] font-extrabold leading-none tabular-nums" style={{ color: styles.accent }}>{kpi.value}</div>
              {kpi.hint && <div className="text-[12px] mt-1" style={{ color: "#5E6875" }}>{kpi.hint}</div>}
            </div>
          )}
          {action && <div className="flex flex-wrap gap-2 max-w-full">{action}</div>}
        </div>
      </div>

      {/* Editorial divider */}
      <div className="mt-6 h-[3px] w-full flex">
        <span className="w-24" style={{ background: styles.accent }} />
        <span className="flex-1 bg-[#CDD7E3]" />
      </div>
    </div>
  );
}
